import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowRight from '@mui/icons-material/ArrowRight';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';

import styles from '../styles/treeItemSelectorModalToggleExpandButton.module.scss';

const TreeItemSelectorModalToggleExpandButton = ({ item, onCollapse, onExpand }) => {
  const {
    isExpanded, children, hasChildren, id,
  } = item;
  if (!hasChildren) return <div className={styles.toggleExpandButtonPlaceholder} />;

  const handleToggleExpandButton = () => (isExpanded
    ? onCollapse({ id, children })
    : onExpand({ id, children }));

  return (
    <Button
      aria-controls={`draggable-${id}`}
      aria-expanded={isExpanded}
      ariaLabel={i18n.t(isExpanded ? 'collapse' : 'expand')}
      onClick={handleToggleExpandButton}
      className={classNames(styles.toggleExpandButton, { [styles.isExpanded]: isExpanded })}
      variant="ghost"
      size="xsmall"
      isDisabled={!children.length}
      icon={<ArrowRight />}
    />
  );
};

TreeItemSelectorModalToggleExpandButton.propTypes = {
  item: PropTypes.shape({
    isExpanded: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.number),
    id: PropTypes.number,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hasChildren: PropTypes.bool,
  }).isRequired,
  onCollapse: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
};

export default React.memo(TreeItemSelectorModalToggleExpandButton);
